import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import axios from 'axios';
import router from './router'

const app = createApp(App)
app.use(router)
app.provide("axios",axios)
//app.use(ElementPlus)
app.use(ElementPlus, {
    locale: {
      ...zhCn, // 继承其他中文配置
      pagination: {
        goto: '前往',
        pagesize: '条/页',
        total: '共 {total} 条记录',
        pageClassifier: '页',
        prevText: '上一页',   // 上一页按钮文本
        nextText: '下一页'    // 下一页按钮文本
      }
    }
  })
app.mount('#app')
